import React, { useState } from "react";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";

const TaxRatesTableDropdown = ({
  data,
  onEdit,
  disabled,
}) => {
  const [dropdownOpen, setOpen] = useState(false);
  const toggle = () => setOpen(!dropdownOpen);

  return (
    <ButtonDropdown isOpen={dropdownOpen} toggle={toggle} disabled={disabled}>
      <DropdownToggle caret outline color="primary">
        Action
      </DropdownToggle>
        <DropdownMenu>
          <DropdownItem
            onClick={() => {
              if (typeof onEdit === "function") onEdit(data);
            }}
            style={{ cursor: "pointer" }}
          >
            Edit
          </DropdownItem>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default TaxRatesTableDropdown;
